/**
 * The clearest message a middleware response carries.
 *
 * Providers answer failures differently — `{meta: {message}}` (CC Storage,
 * StorEdge), `{error}`, `{errors: [{message}]}` (CC Storage passes the
 * facility API's own errors straight through), or DRF field errors — so a
 * caller that reads only one of those shows the agent an empty alert. Falls
 * back to `fallback` when nothing readable came back.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export default function serverMessage(response: any, fallback: string): string {
  const body = response ? response.body : null;
  if (typeof body === "string") {
    const text = body.trim();
    // an HTML error page is not a message worth showing an agent
    if (text && text.length < 300 && !text.startsWith("<")) {
      return text;
    }
  }
  if (body && typeof body === "object") {
    if (body.meta && body.meta.message) {
      return body.meta.message;
    }
    for (const key of ["error", "message", "detail"]) {
      if (typeof body[key] === "string" && body[key]) {
        return body[key];
      }
    }
    if (Array.isArray(body.errors)) {
      const parts = body.errors
        .map((item: unknown) =>
          typeof item === "string"
            ? item
            : // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (item as any)?.message || (item as any)?.detail || ""
        )
        .filter((text: string) => text);
      if (parts.length) {
        return parts.join(" ");
      }
    }
    // DRF field errors: { field: ["message"] }
    const fields = Object.keys(body)
      .filter(
        (key) => Array.isArray(body[key]) && typeof body[key][0] === "string"
      )
      .map((key) => `${key}: ${body[key][0]}`);
    if (fields.length) {
      return fields.join(" ");
    }
  }
  return fallback;
}
